import { SettingsIcon } from '@mm/icons';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import modalActions from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import './DialogueSettingsButton.pcss';

export const DialogueSettingsButton = ({
  pageId,
}: {
  pageId?: number | null;
}) => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  if (!pageId) {
    return null;
  }

  const openModal = () =>
    dispatch(modalActions.openDialogueSettingsModal(pageId));

  return (
    <div className="dialogue-settings-button" onClick={openModal}>
      <SettingsIcon className="dialogue-settings-button__settings-icon" />
      Dialogue Settings
    </div>
  );
};
